import { KC_CLIENT, KC_REALM, KC_URL } from 'Config/constantes';
import Keycloak from 'keycloak-js';
// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'

const keycloak = new Keycloak({
    url: KC_URL,
    realm: KC_REALM,
    clientId: KC_CLIENT,
})

// Configuration pour le rafraîchissement automatique du token
keycloak.onTokenExpired = () => {
    keycloak.updateToken(70).catch((error) => {
        console.error('Failed to refresh token:', error);
    });
};

export default keycloak